import Sidebar from "@/components/sidebar/Sidebar";
import "./wrapper.css";
import Header from "@/components/header/Header";
import BottomNav from "@/client/components/bottom-nav/BottomNav";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

const Wrapper = ({ children }) => {
  return (
    // <div className="client bg-gradient-to-br from-[#dfeaf9] to-[#E6EDF7] h-full">
    <div className="client bg-[#E7EEF6] h-full">
      {/* <Avatar className="size-40 absolute top-40 right-4">
        <AvatarImage src="https://github.com/shadcn.png" />
        <AvatarFallback>CN</AvatarFallback>
      </Avatar> */}
      <div className="home-container">
        <Sidebar />
        <main className={`w-[calc(100%-210px)] max-[770px]:w-full`}>
          <Header />
          <div className="main h-[calc(100vh-96px)] p-4 pb-5 relative overflow-y-auto ">
            {children}
          </div>
        </main>
        <BottomNav />
      </div>
    </div>
  );
};

export default Wrapper;
